import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import { ADD_MODE, EDIT_MODE, READ_MODE, EntityFormHeaderTitle } from "../../../../common/entity-form";

const GroupFormHeaderTitle = ({
    groupId,
    mode,
    onBackClick
}) => {
    const intl = useIntl();

    const titleValues ={ groupId };

    const titleMap = {
        [ADD_MODE]: intl.formatMessage({ id: "group-form-page-header.new.title" }),
        [EDIT_MODE]: intl.formatMessage({ id: "group-form-page-header.edit.title" }, titleValues),
        [READ_MODE]: intl.formatMessage({ id: "group-form-page-header.read.title" }, titleValues),
    };

    return (
        <EntityFormHeaderTitle
            title={titleMap[mode]}
            onBackClick={onBackClick}
        />
    );
};

GroupFormHeaderTitle.propTypes = {
    groupId: PropTypes.string,
    mode: PropTypes.string,
    onBackClick: PropTypes.func
};

export default GroupFormHeaderTitle;
